import { NEW_KITCHEN_CDN_PATH } from '../../new-kitchen-constants';
import { Delivery, Done, Guarantee, Showrooms } from './components';

export type NewKitchenHeaderItemStructure = {
  text: string;
  icon: {
    src: string;
    alt: string;
  };
  modal: React.FC<{ onCloseModal: () => void }>;
};

export const NEW_KITCHEN_HEADER_ITEMS: NewKitchenHeaderItemStructure[] = [
  {
    text: 'Через 10\u00A0дней новая\nкухня у\u00A0вас дома*',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/delivery.png/delivery1.png`,
      alt: 'Изготовление за 10 дней',
    },
    modal: Delivery,
  },
  {
    text: 'Гарантия 25\u00A0лет\nна\u00A0все изделия',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/guarantee.png/guarantee1.png`,
      alt: 'Гарантия 25 лет',
    },
    modal: Guarantee,
  },
  {
    text: 'Реализовано более\n1\u00A0млн проектов',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/done.png/done1.png`,
      alt: 'Реализованные проекты',
    },
    modal: Done,
  },
  {
    text: 'Шоурумы\nв\u00A0112 магазинах',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/showrooms.png/showrooms1.png`,
      alt: 'Шоурумы в магазинах',
    },
    modal: Showrooms,
  },
];
